import type {
  AddCityInput,
  GetCitiesByStatesInput,
} from "shared/types/general";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const getCountries = async () => {
  try {
    const url = "/countries/all";
    const response = await axiosClient.get(url);
    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData?.success &&
      responseData?.statusCode === 200 &&
      responseData?.data?.result &&
      Array.isArray(responseData?.data?.result)
    ) {
      return responseData?.data?.result;
    } else {
      throw new Error(responseData?.message);
    }
  } catch (error) {
    throw error;
  }
};

const getStatesByCountryId = async (countryId?: string) => {
  try {
    const url = `/states/country_code/${countryId}`;
    const response = await axiosClient.get(url);

    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData?.success &&
      responseData?.statusCode === 200 &&
      responseData?.data?.result &&
      Array.isArray(responseData?.data?.result)
    ) {
      return responseData?.data?.result;
    } else {
      throw new Error(responseData?.message);
    }
  } catch (error) {
    throw error;
  }
};

const getCitiesByStates = async (data: GetCitiesByStatesInput) => {
  const { countryId, stateId, mspId } = data;
  try {
    const url = `/cities/country_code/${countryId}/state_code/${stateId}?msp_id=${mspId}`;
    const response = await axiosClient.get(url);

    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData?.success &&
      responseData?.statusCode === 200 &&
      responseData?.data?.result &&
      Array.isArray(responseData?.data?.result)
    ) {
      return responseData?.data?.result;
    } else {
      throw new Error(responseData?.message);
    }
  } catch (error) {
    throw error;
  }
};

const getAllTimeZone = async () => {
  try {
    const url = "/timezones/all";
    const response = await axiosClient.get(url);
    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData?.success &&
      responseData?.statusCode === 200 &&
      responseData?.data?.result &&
      Array.isArray(responseData?.data?.result)
    ) {
      return responseData?.data?.result;
    } else {
      throw new Error(responseData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getUrlMetaData = async (url: string) => {
  try {
    const baseUrl = "/generalRoute/url";

    const response = await axiosClient.post(baseUrl, { url });
    const responseData = response.data;
    if (response.status === 200) {
      return responseData?.data;
    } else {
      throw new Error(responseData?.message);
    }
  } catch (error) {
    throw error;
  }
};

const addCity = async (data: AddCityInput) => {
  try {
    const url = "/cities";
    const response = await axiosClient.post(url, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export {
  getCountries,
  getStatesByCountryId,
  getCitiesByStates,
  getAllTimeZone,
  addCity,
};
